import Entity from './entity'
export default class User extends Entity<number>{
    password:string;
    userName: string;
    workingWarehouseCode :string;
    name: string;
    roleNames : Array<string>;
    tenantName:string;
    roleIds: Array<number>;
    clientCode :string;
    clientName:string;

    formatName: string;
    isLockoutEnabled: boolean;
}